var _circle, _circle2, _circle3, _circle4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.6327,
    cy: 82.6324,
    r: 74.0531,
    transform: "rotate(-90 82.6327 82.6324)",
    stroke: "#8B80DB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 83,
    cy: 83,
    r: 82.5,
    transform: "rotate(-90 83 83)",
    stroke: "#8B80DB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 82.9998,
    cy: 83.0002,
    r: 50.6814,
    transform: "rotate(-90 82.9998 83.0002)",
    fill: "#8B80DB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 83.0006,
    r: 11.6667,
    stroke: "#8B80DB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 83.0007H83.25C83.1119 83.0007 83 82.8887 83 82.7507V78.334",
    stroke: "#8B80DB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSuccess);
export default __webpack_public_path__ + "static/media/transaction-success.121d6dbfccec779eddbdea473bdcbd4d.svg";
export { ForwardRef as ReactComponent };